import $ from "jquery";

const SELECTOR_HOURS = '[data-js="jsHours"]';
const SELECTOR_HOURS_TEXT = '[data-js="jsHoursText"]';
const SELECTOR_HOURS_TITLE = '[data-js="jsHoursTitle"]';

const copyHoursText = function () {
  $(SELECTOR_HOURS_TEXT).each(function () {
    $(this)
      .closest(SELECTOR_HOURS)
      .find(SELECTOR_HOURS_TITLE)
      .html($(this).html());
    $(this).remove();
  });
};

$(function () {
  copyHoursText();
});
